module.exports = __webpack_public_path__ + "media/assets/icons/finance-97b42586ead207b75bf8c183dd0ba2b8.svg";